<ion-menu side="end" contentId="main-content" menuId="selectorMenu"
class="cigarSelector" swipeGesture="false">
  <ion-header>
    <ion-toolbar>
      <ion-title>
        {{"cigar-selector.cigar-selector" | translate}}
      </ion-title>
      <ion-buttons slot="end">
        <ion-button (click)="closeCigarSelector()">
        <ion-icon name="close-circle-outline" size="large">

        </ion-icon>
        </ion-button>

      </ion-buttons>

    </ion-toolbar>
  </ion-header>
  <ion-content id="cSContent">
  <form [formGroup]="selectorForm">
    <ion-list>
      <ion-item lines="none">
        <ion-label position="stacked">
          {{"cigar-selector.smoking-duration" | translate}}:
          <ng-container *ngIf="selectorForm.value.duration.upper<120">
            {{selectorForm.value.duration.lower}} - &le; {{selectorForm.value.duration.upper}} min
          </ng-container>
          <ng-container *ngIf="selectorForm.value.duration.upper>=120">
            {{selectorForm.value.duration.lower}} - &ge; {{selectorForm.value.duration.upper}} min
          </ng-container>
        </ion-label>
        <ion-range  min="0" max="120" step="5" value="120" color="secondary" aria-label="smoking duration"
        name="duration" ticks="true" snaps="true" dual-knobs="true" formControlName="duration" label-placement="stacked"
        (ionChange)="setAttribute('duration',{min:selectorForm.value.duration.lower,max:selectorForm.value.duration.upper})">
          <ion-text slot="start">0</ion-text>
          <ion-text slot="end">&ge;120min</ion-text>
        </ion-range>
      </ion-item>
      <ion-item lines="none">
        <ion-label position="stacked">
          {{"cigar-selector.price" | translate}}:
          <ng-container *ngIf="selectorForm.value.price.upper<1000">
            {{selectorForm.value.price.lower}} - &le; {{selectorForm.value.price.upper | currency : currency : 'symbol-narrow' : '1.2' : language}}
          </ng-container>
          <ng-container *ngIf="selectorForm.value.price.upper>=1000">
            {{selectorForm.value.price.lower}} - &ge; {{selectorForm.value.price.upper | currency : currency : 'symbol-narrow' : '1.2' : language}}
          </ng-container>
        </ion-label>
        <ion-range  min="0" max="1000" step="50" value="1000" color="secondary" aria-label="selector price"
        name="price" ticks="true" snaps="true" dual-knobs="true" formControlName="price"
        (ionChange)="setAttribute('price',{min:selectorForm.value.price.lower,max:selectorForm.value.price.upper})">
          <ion-text slot="start">0</ion-text>
          <ion-text slot="end">&ge; {{1000 | currency : currency : 'symbol-narrow' : '1.2' : language}}</ion-text>
        </ion-range>
      </ion-item>
      <ion-item lines="none">
        <ion-label position="stacked">
          {{"cigar-selector.strength" | translate}}: {{ strength.value }}
          <ng-container [ngSwitch]="strength.value">
            (
            <ng-container *ngSwitchCase="1">{{"cigar-selector.mild" | translate}}</ng-container>
            <ng-container *ngSwitchCase="2">{{"cigar-selector.mild-medium" | translate}}</ng-container>
            <ng-container *ngSwitchCase="3">{{"cigar-selector.medium" | translate}}</ng-container>
            <ng-container *ngSwitchCase="4">{{"cigar-selector.medium-full" | translate}}</ng-container>
            <ng-container *ngSwitchCase="5">{{"cigar-selector.full" | translate}}</ng-container>
            <ng-container *ngSwitchDefault>{{"cigar-selector.not-selected" | translate}}</ng-container>
            )
          </ng-container>
        </ion-label>
        <ion-range  min="0" max="5" step="1" value="0" color="secondary" aria-label="selector strength"
        name="strength" ticks="true" snaps="true" dual-knobs="false"
        #strength (ionChange)="setAttribute('strength',strength.value)" formControlName="strength">
          <ion-text slot="start">0</ion-text>
          <ion-text slot="end">5 ( {{"cigar-selector.full" | translate}} )</ion-text>
        </ion-range>
      </ion-item>
      <ion-item lines="none">
        <ion-label position="stacked">
          {{"cigar-selector.riping-time" | translate}}:
          <ng-container *ngIf="ripingtime.value!==0">
            {{ripingtime.value}} {{"cigar-selector.month-more" | translate}}
          </ng-container>
          <ng-container *ngIf="ripingtime.value===0">
            {{"cigar-selector.not-considered" | translate}}
          </ng-container>
        </ion-label>
        <ion-range  min="0" max="36" step="3" value="0" color="secondary" aria-label="selector riping time"
        name="ripingtime" ticks="true" snaps="true" dual-knobs="false"
        #ripingtime (ionChange)="setAttribute('ripingtime',ripingtime.value)" formControlName="ripingtime">
          <ion-text slot="start">0</ion-text>
          <ion-text slot="end">&ge;36 {{"cigar-selector.month" | translate}}</ion-text>
        </ion-range>
      </ion-item>

      <ion-item lines="none">
        <ion-label position="stacked">
          {{"cigar-selector.rating" | translate}}:
          <ng-container *ngIf="rating.value!==0">
            <ng-container *ngIf="rating.value===1">
              {{"smoking-protocol.ungenügend" | translate}} (0-19
            </ng-container>
            <ng-container *ngIf="rating.value===2">
              {{"smoking-protocol.mangelhaft" | translate}} (20-39
            </ng-container>
            <ng-container *ngIf="rating.value===3">
              {{"smoking-protocol.ausreichend" | translate}} (40-54
            </ng-container>
            <ng-container *ngIf="rating.value===4">
              {{"smoking-protocol.befriedigend" | translate}} (55-69
            </ng-container>
            <ng-container *ngIf="rating.value===5">
              {{"smoking-protocol.gut" | translate}} (70-84
            </ng-container>
            <ng-container *ngIf="rating.value===6">
              {{"smoking-protocol.sehrgut" | translate}} (85-100
            </ng-container>
            {{"smoking-protocol.points" | translate}})
          </ng-container>
          <ng-container *ngIf="rating.value===0">
            {{"cigar-selector.not-considered" | translate}}
          </ng-container>
        </ion-label>
        <ion-range  min="0" max="6" step="1" value="0" color="secondary"
        name="rating" ticks="true" snaps="true" dual-knobs="false" aria-label="selector rating"
        #rating (ionChange)="setAttribute('rating',rating.value)" formControlName="rating">
          <ion-text slot="start">x</ion-text>
          <ion-text slot="end">{{"smoking-protocol.sehrgut" | translate}} (85-100) </ion-text>
        </ion-range>
      </ion-item>
      <ion-item lines="none">
        <ion-select formControlName="fitting_drink" #fitting_drink interface="action-sheet" [okText]="'addcigar-form.choose' | translate"
        [cancelText]="'addcigar-form.cancel' | translate" [label]="'cigar-selector.fitting-beverage' | translate" label-placement="stacked"
        (ionChange)="setAttribute('fitting_drink',fitting_drink.value)">
          <ion-select-option *ngFor="let drink of drinks" [value]="drink.identifier" [class]="'drink-'+drink.identifier">
            {{"beverages."+drink.identifier | translate}}
          </ion-select-option>
        </ion-select>
      </ion-item>
      <ion-item lines="none">
        <ion-select formControlName="aromaselector" #aromaselector interface="ion-popover" [label]="'cigar-selector.aromas' | translate" label-placement="stacked"
        (ionChange)="setAttribute('aromas',aromaselector.value)"  multiple="true" [okText]="'addcigar-form.choose' | translate"
        [cancelText]="'addcigar-form.cancel' | translate">
          <ion-select-option *ngFor="let aroma of aromas" [value]="aroma.identifier" [class]="'aroma-'+aroma.identifier">
            {{"flavors."+aroma.identifier | translate}}
          </ion-select-option>
        </ion-select>
      </ion-item>
      <ion-item lines="none" class="no-border">
        <ion-button expand="block" (click)="resetSelector()" color="secondary" id="csResetButton">
          重置
        </ion-button>
      </ion-item>
    </ion-list>
  </form>
  </ion-content>

</ion-menu>
